module.exports = __webpack_public_path__ + "assets/1792649897182/img/center-success-logo.03f2f065.png";